import { apiClient } from "@/lib/api-client"
import type {
  EngageEmployeeDto,
  DistributionType,
  DistributionRunDto,
  SendEmployeeDocumentResultDto,
} from "../dtos/engage.dto"

export async function listEmployees(organizationId: string): Promise<EngageEmployeeDto[]> {
  const response = await apiClient.get<EngageEmployeeDto[]>(
    `/organizations/${organizationId}/engage/employees`,
  )
  return response.data
}

export async function sendPayslip(
  organizationId: string,
  employeeId: string,
): Promise<SendEmployeeDocumentResultDto> {
  const response = await apiClient.post<SendEmployeeDocumentResultDto>(
    `/organizations/${organizationId}/engage/employees/${employeeId}/send-payslip`,
  )
  return response.data
}

export async function sendIrp5(
  organizationId: string,
  employeeId: string,
): Promise<SendEmployeeDocumentResultDto> {
  const response = await apiClient.post<SendEmployeeDocumentResultDto>(
    `/organizations/${organizationId}/engage/employees/${employeeId}/send-irp5`,
  )
  return response.data
}

export async function startDistribution(
  organizationId: string,
  type: DistributionType,
): Promise<DistributionRunDto> {
  const response = await apiClient.post<DistributionRunDto>(
    `/organizations/${organizationId}/engage/distribution-runs`,
    { type },
  )
  return response.data
}

export async function listDistributionRuns(organizationId: string): Promise<DistributionRunDto[]> {
  const response = await apiClient.get<DistributionRunDto[]>(
    `/organizations/${organizationId}/engage/distribution-runs`,
  )
  return response.data
}

export async function getDistributionRun(
  organizationId: string,
  runId: string,
): Promise<DistributionRunDto> {
  const response = await apiClient.get<DistributionRunDto>(
    `/organizations/${organizationId}/engage/distribution-runs/${runId}`,
  )
  return response.data
}

export const engageApi = {
  listEmployees,
  sendPayslip,
  sendIrp5,
  startDistribution,
  listDistributionRuns,
  getDistributionRun,
}
